export default {
  refund: 'Reembolso',
  refund_instructions: 'Instrucciones de reembolso',
  customer_order_no: 'Número de orden del cliente',
  transaction_type: 'Tipo de transacción',
  merchant_order_id: 'ID de orden del comercio',
  create_time: 'Fecha y hora de creación',
  creator: 'Creador',
  transaction_amount: 'Monto de la transacción',
  transaction_status: 'Estado de la transacción',
  fee: 'Tarifa',
  institute_id: 'ID de canal',
  merchant_name: 'Nombre del comercio',
  product_name: 'Nombre del producto',
  refundable_amount: 'Monto reembolsable',
  payment_details: 'Detalles del cobro',
  payout_details: 'Detalles del pago',
  payment: 'Cobro / Pay-in',
  payout: 'Pago / Payout',
  disburse: 'Desembolso',
  payment_serial_number: 'Número de referencia del cobro',
  stream_creation_time: 'Fecha y hora de creación del flujo',
  organization_return_order_time: 'Fecha y hora de respuesta de la institución',
  retry_notice: 'Reintentar pago',
  mobile: 'Teléfono celular',
  customer_phone_number: 'Número de teléfono del cliente',
  account_no: 'Código de pago',
  account_number: 'Código de pago',
  bill_account_no: 'Código de pago',
  qr_link: 'Enlace del código QR',
  qr_download: 'Enlace de descarga',
  qr_code_id: 'ID del código QR',
  work_order_number: 'Número de ticket',
  institution_type: 'Tipo de canal',
  business_type: 'Tipo de negocio',
  transaction_id: 'ID de transacción',
  reference_no: 'Número de documento',
  void_transaction_id: 'ID de transacción cancelada',
  void_complete_time: 'Fecha y hora de finalización de cancelación',
  issue: 'Problema',
  conclusion: 'Conclusión',
  replies: 'Respuestas',
  reply: 'Responder',
  reopen: 'Reabrir',
  cs_intervention_time: 'Fecha y hora de intervención de atención al cliente',
  cs_completion_time: 'Fecha y hora de finalización de la atención al cliente',
  image: 'Imagen',
  add_work_order: 'Crear nuevo ticket',
  payment_code: 'Código de pago',
  app_name: 'Nombre de la aplicación',
  payer_mobile: 'Número de Teléfono del pagador',
  remitting_bank: 'Banco remitente',
  remittance_account: 'Cuenta de origen',
  payment_method: 'Método de pago',
  description: 'Descripción',
  transaction_history: 'Historial de transacciones',
  payment_receipt: 'Comprobante de pago',
  attachments: 'Archivos adjuntos',
  reference: 'Referencia',
  submit_quantity: 'Cantidad enviada',
  success_quantity: 'Exitosos',
  pending_quantity: 'En proceso',
  fail_quantity: 'Fallidos',
  validation: 'Validación',
  single_payment_link: 'Crear enlace único',
  batch_payment_link: 'Crear enlaces masivos',
  create_single_payment_link: 'Enlace de pago único',
  create_batch_payment_link: 'Enlace de pago por lotes',
  payment_channel: 'Canal de pago',
  email_content: 'Contenido del correo',
  beneficiary_mobile: 'Teléfono del beneficiario',
  email_address: 'Correo del beneficiario',
  customer_name: 'Nombre del cliente',
  download_template: 'Descargar plantilla',
  upload_file_template: 'Subir plantilla completada',
  edit_collection: 'Editar enlace',
  payin_search: 'Consulta de cobros',
  payout_search: 'Consulta de pagos',
  card_verification_search: 'Consulta de verificación de tarjetas',
  other_details: 'Otros detalles',
  ticket_details: 'Detalles del ticket',
  re_open_ticket: 'Reabrir ticket',
  qr_invoice_no: 'Número de factura QR',
  invoice_no: 'Número de factura',
  wayBill_num: 'Número de guía',
  wayBill_status: 'Estado de la guía',
  refund_search: 'Búsqueda del reembolsos',
  original_transaction_id: 'ID de transacción original',
  refund_type: 'Tipo de reembolso',
  full_refund: 'Reembolso total',
  partial_refund: 'Reembolso parcial',
  original_transaction_amount: 'Monto original de la transacción',
  refund_transaction_id: 'ID de transacción de reembolso',
  refund_amount_already: 'Monto ya reembolsado',
  present_refund_amount: 'Monto a reembolsar actual',
  refund_order_amount: 'Monto de orden de reembolso',
  refund_fee: 'Comisión por reembolso',
  refund_failed_fee: 'Comisión por reembolso (Reembolso fallido)',
  amount_to_receive: 'Monto a recibir',
  refund_fee_charge_mode: 'Modo de asignación de comisión por reembolso',
  refund_reason: 'Motivo del reembolso',
  cumulative_amount_refunded: 'Monto acumulado de órdenes reembolsadas',
  remaining_refundable_order_amount: 'Monto restante de la orden reembolsable',
  original_transaction_fee_charge_mode: 'Modo original de asignación de comisión',
  total_refunded_amount: 'Monto total reembolsado',
  refund_status: 'Estado del reembolso',
  refund_transaction_details: 'Detalles de la transacción de reembolso',
  refund_amount: 'Monto del reembolso',
  refunded_transaction_fee: 'Monto de comisión devuelto',
  refund_commission_amount: 'Monto de comisión a devolver',
  refund_commission_amount_summary: 'Resumen de comisiones a devolver',
  refund_commission_amount_number: 'Cantidad de comisiones a devolver',
  refund_transactions_number: 'Cantidad de transacciones de reembolso',
  refund_channel_refund_fee_amount: 'Monto de comisiones devueltas por el canal',
  refunds_summary: 'Resumen de transacciones de reembolso',
  full_refund_summary: 'Resumen de montos totales reembolsados',
  return_fee_summary: 'Resumen de comisiones devueltas',
  total_refund_fee: 'Resumen de comisiones por reembolso',
  actual_refund_amount_received: 'Monto recibido por el iniciador del reembolso',
  refund_transaction_amount: 'Monto de la transacción de reembolso',
  transaction_fee_change_mode: 'Responsable de la comisión',
  refund_order_status: 'Estado de la orden de reembolso',
  request_refund_amount: 'Monto de reembolso solicitado',
  refund_transaction_status: 'Estado de la transacción de reembolso',
  refund_transactions_number_summary: 'Resumen de cantidad de reembolsos',
  remaining_refundable_amount: 'Monto restante reembolsable',
  process_refund_transactions: 'Procesar transacciones de reembolso',
  process_refund_details: 'Detalles del procesamiento del reembolso',
  handle_time: 'Fecha y hora de procesamiento',
  mch_refund_order_id: 'ID de orden de reembolso del comercio',
  bill_no: 'Número de factura',
  bill: 'Factura',
  loan_type: 'Tipo de préstamo',
  customer_no: 'Número de cliente',
  beneficiary_account: 'Cuenta del beneficiario',
  loan_channel: 'Canal de préstamo',
  asset_belonged: 'Titular del activo',
  funding_parties: 'Financiadores',
  credit_type: 'Tipo de crédito',
  loan_amount: 'Monto del préstamo',
  credit_service: 'Servicio de crédito',
  current_fx: 'Tipo de cambio',
  repay_method: 'Método de pago de deuda',
  repayment_amount: 'Monto de amortización',
  down_payment_amount: 'Monto del pago inicial',
  installment_amount: 'Monto de la cuota',
  payment_order_number: 'Número de orden de pago',
  loan_status: 'Estado del préstamo',
  collection_channel_type: 'Tipo de canal de cobro',
  account: 'Número de cuenta',
  payee_type: 'Tipo de beneficiario',
  payee_id_number: 'Número de Documento de identidad del beneficiario',
  payee_relationship: 'Relación con el beneficiario',
  payee_phone_number: 'Teléfono del beneficiario',
  bill_amount: 'Monto de la factura',
  principal_repayment_amount: 'Capital',
  penalty_repayment_amount: 'Penalización',
  interest: 'Interesed',
  installment_term: 'Número de plazos',
  due_date: 'Fecha de vencimiento',
  loan_transaction_no: 'Númerode transacción del préstamo',
  repay_transaction_no: 'Número de transacción de amortización',
  transaction_id_wallet: 'Número de pago',
  amount: 'Monto del préstamo',
  installment_amount_wallet: 'Monto del préstamo',
  status: 'Estado de la transacción',
  jt_issuer_name: 'Método de pago',
  aggregate_cod_Amount: 'Monto total de COD',
  aggregate_cod_fee_amount: 'Comisión total de COD',
  aggregate_frt_amount: 'Monto total de flete',
  aggregate_frt_fee_amount: 'Comisión total de flete',
  transaction_fee_charge_mode: 'Modo de asignación de comisión',
  charge_to_merchants: 'Asumido por el comercio',
  charge_to_customer: 'Asumido por el usuario',
  payment_type: 'Tipo de pago',
  paid_account_no_suffix: 'Sufijo de la cuenta pagadora',
  billing_address: 'Dirección de facturación',
  qr_stand_id: 'ID de QR Stand',
  amount_refunded_successfully: 'Monto reembolsado con éxito',
  pay_card_no: 'Número de tarjeta',
  pay_card_scheme: 'Esquema de tarjeta',
  pay_card_issuer: 'Emisor'
}
